import { useEffect, useMemo, useState } from "react";
import { useBankTransfers } from "../../../hooks/useBankTransfers";
import { isBankTransferActive } from "../../../lib/bankTransferStore";
import ziraatLogo from "../../../assets/Ziraat-Bankasi-logo.png";

function isOlderThanTwoMinutes(value?: string) {
  const time = new Date(value || 0).getTime();
  if (!Number.isFinite(time)) return true;
  return Date.now() - time >= 2 * 60 * 1000;
}

export default function HavaleTvPage() {
  const { transfers } = useBankTransfers();
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => setTick((value) => value + 1), 30000);
    return () => window.clearInterval(timer);
  }, []);

  const rows = useMemo(() => {
    void tick;
    return transfers
      .filter((item) => isBankTransferActive(item) && isOlderThanTwoMinutes(item.createdAt))
      .sort((a, b) => String(b.createdAt).localeCompare(String(a.createdAt)));
  }, [tick, transfers]);

  return (
    <div className="min-h-screen overflow-hidden bg-[#f6f1e7] px-4 py-5 font-body text-[#513b2a]">
      <div className="mx-auto max-w-[1400px] space-y-4">
        <div className="rounded-[24px] border border-[#eadfcf] bg-white px-5 py-4 shadow-sm">
          <div className="flex items-center justify-between gap-4">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full bg-[#efe2d3] px-3 py-1 text-[12px] font-bold uppercase tracking-[0.2em] text-[#8a613f]">
                <i className="ri-bank-card-line" /> Havale TV
              </div>
              <h1 className="mt-3 font-heading text-3xl font-bold">Evren Çiftliği Havale Ekranı</h1>
              <p className="mt-1 text-sm text-[#8f7a68]">Sadece aktif havaleler görünür. Yeni yüklenen kayıtlar 2 dakika gecikmeli listelenir.</p>
              <div className="mt-4 rounded-2xl border border-[#eadfcf] bg-[#fffaf2] p-3">
                <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
                  <img src={ziraatLogo} alt="Ziraat Bankası" className="h-12 w-auto object-contain lg:h-14" />
                  <div className="grid gap-1 text-sm font-semibold text-[#513b2a]">
                    <div><span className="text-[#8f7a68]">Sayın</span> SAİT EVREN</div>
                    <div><span className="text-[#8f7a68]">Hesap Numarası:</span> 130-68383767-5002 ÇATALCA/İSTANBUL ŞUBESİ TL</div>
                    <div><span className="text-[#8f7a68]">IBAN:</span> TR950001000130683837675002</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-2xl bg-[#6b4c35] px-5 py-3 text-right text-white">
              <p className="text-xs uppercase tracking-[0.18em] text-white/70">Aktif Kayıt</p>
              <p className="mt-1 text-3xl font-black">{rows.length}</p>
            </div>
          </div>
        </div>

        <div className="rounded-[24px] border border-[#eadfcf] bg-white shadow-sm overflow-hidden">
          <div className="grid grid-cols-[190px_1fr] bg-[#6b4c35] px-5 py-3 text-sm font-black uppercase tracking-[0.18em] text-white">
            <div>Fiş No</div>
            <div>Açıklama</div>
          </div>

          <div className="max-h-[calc(100vh-360px)] overflow-hidden">
            <div className="animate-[transferTicker_35s_linear_infinite] divide-y divide-[#eadfcf]">
              {rows.length === 0 ? (
                <div className="px-5 py-20 text-center text-2xl font-bold text-[#8f7a68]">Şu anda aktif havale kaydı yok.</div>
              ) : (
                [0, 1].flatMap((loop) => [
                  ...rows.map((item) => (
                    <div key={`${item.id}-${loop}`} className="grid grid-cols-[190px_1fr] items-center px-5 py-4 text-2xl font-bold">
                      <div className="text-[#9b6a43]">{item.fisNo}</div>
                      <div className="break-words leading-tight">{String(item.aciklama || "—")}</div>
                    </div>
                  )),
                  <div key={`end-${loop}`} className="px-5 py-5 text-center text-base font-black uppercase tracking-[0.3em] text-[#9b6a43]">
                    ───── Listenin Sonu ─────
                  </div>,
                ])
              )}
            </div>
          </div>
        </div>
      </div>

      <style>{`@keyframes transferTicker { 0% { transform: translateY(0); } 100% { transform: translateY(-50%); } }`}</style>
    </div>
  );
}
